import React from "react";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";
import styles from "./PoliciesPage.module.scss";
import BreadCrumb from "src/components/shared/breadCrumb/Index";
import { FormattedMessage } from "react-intl";
import { Container } from "react-bootstrap";

const Footer = dynamic(() => import("src/components/shared/Footer/Footer"));
const PageHeader = dynamic(
  () => import("src/components/shared/PageHeader/PageHeader"),
);

const PoliciesPage = ({ data, footerSettings }) => {
  const { locale: lang } = useRouter();
  const title = data?.title?.[lang];
  const content = data?.content?.[lang];

  return (
    <>
      <PageHeader />
      <BreadCrumb title={<FormattedMessage id="policies" />} />
      <Container>
        <div className={styles.content}>
          {title && <h1>{title}</h1>}
          {content && (
            <div
              className={styles.contentText}
              dangerouslySetInnerHTML={{ __html: content }}
            />
          )}
        </div>
      </Container>
      <Footer footerLinks={footerSettings} />
    </>
  );
};

export default PoliciesPage;
